// noinspection SpellCheckingInspection

import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';

const sanitizeSchema = {
  ...defaultSchema,
  tagNames: [
    ...(defaultSchema.tagNames ?? []),
    'table', 'thead', 'tbody', 'tr', 'th', 'td',
    'a',
  ],
  attributes: {
    ...(defaultSchema.attributes),
    table: [
      ...(defaultSchema.attributes?.table ?? []),
      'align', 'border', 'cellpadding', 'cellspacing'
    ],
    th: [
      ...(defaultSchema.attributes?.th ?? []),
      'align', 'colspan', 'rowspan', 'scope'
    ],
    td: [
      ...(defaultSchema.attributes?.td ?? []),
      'align', 'colspan', 'rowspan', 'headers'
    ],
    a: [
      ...(defaultSchema.attributes?.a ?? []),
      'href', 'title', 'target', 'rel'
    ],
  },
};

const MarkdownLink = (props: React.AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const { children, ...rest } = props;
  return <a target="_blank" rel="noopener noreferrer" {...rest}>{children}</a>;
};

type Props = { children: string };

export default function MarkdownRenderer({ children }: Readonly<Props>) {
  return (
    <div className="prose max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[
          rehypeRaw,
          [rehypeSanitize, sanitizeSchema]
        ]}
        components={{ a: MarkdownLink }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
